import React from 'react'
import Check from '../Check'
import PropTypes from 'prop-types'

const Checkbox = ({
    label,
    ...props
}) => <Check {...props} type='checkbox' ariaLabel={props.label} label={label} />

Checkbox.propTypes = {
    label: PropTypes.string,
}

export default Checkbox
